const module1 = [
  // {
  //   path: '/leshua',
  //   component: resolve => require(['@/page/index.vue'], resolve)
  // },
  {
    path: '/supplierGreightTemplate',
    component: resolve => require(['@/page/logistics/index.vue'], resolve)
  },
  {
    path: '/liveLogisticsEdit',
    component: resolve => require(['@/page/logistics/edit.vue'], resolve)
  },
  {
    path: "/mall/afterSaleOrder",
    component: resolve => require(['@/page/afterSaleOrder/index.vue'], resolve)
  },
  {
    path: '/product',
    component: resolve => require(['@/page/product/index.vue'], resolve)
  },
  {
    path: '/productUpload',
    component: resolve => require(['@/page/product/upload.vue'], resolve)
  },
  //店铺基本信息
  {
    path: "/suppliershopinfo",
    name: "suppliershopinfo",
    component: () => import("@/page/suppliershopinfo")
  },
  {
    path:"/order",
    component: resolve => require(['@/page/order/index.vue'], resolve)
  },
  {
    path: "/supplierShopSettle",
    component: resolve => require(['@/page/capitalCenter/capitalCenter.vue'], resolve)
  },
  {
    path: "/payment",
    component: resolve => require(['@/page/capitalCenter/payment.vue'], resolve)
  },
  {
    path: "/speciesPay",
    component: resolve => require(['@/page/capitalCenter/speciesPay.vue'], resolve)
  },
  {
    path: "/rules",
    component: resolve => require(['@/page/capitalCenter/rules.vue'], resolve)
  },
  
]
export default module1



// WEBPACK FOOTER //
// ./src/router/module/module1.js